/** PUT direto no S3 via URL presigned. O presign fixa o ContentType: o header precisa bater. */
export async function uploadImage(uploadUrl, file, contentType) {
    const res = await fetch(uploadUrl, {
        method: "PUT",
        headers: { "Content-Type": contentType },
        body: file,
    });
    if (!res.ok) {
        throw new Error(`Upload falhou (${res.status})`);
    }
}

/** Arte corrigida enviada pela revisão: sempre `image/png`. */
export async function uploadPng(uploadUrl, file) {
    return uploadImage(uploadUrl, file, "image/png");
}
